import { useSubscriptionStore } from "@/stores/subscriptionStore";
import {
  defaultRuntimePricingCatalog,
  getDefaultTopUpOfferCode,
  type PricingServiceKey,
} from "@/features/pricing/runtimePricing";

export function useRuntimePricingCatalog() {
  return useSubscriptionStore((state) => state.pricingCatalog ?? defaultRuntimePricingCatalog);
}

export function useRuntimeServicePricing(serviceKey: PricingServiceKey) {
  return useSubscriptionStore(
    (state) => state.pricingCatalog.servicePricing[serviceKey]
      ?? defaultRuntimePricingCatalog.servicePricing[serviceKey],
  );
}

export function useRuntimeCreditCost(serviceKey: PricingServiceKey) {
  return useRuntimeServicePricing(serviceKey).creditCost;
}

export function useDefaultTopUpOfferCode() {
  return useSubscriptionStore((state) => getDefaultTopUpOfferCode(state.pricingCatalog));
}
